<template>
	<v-container class="pt-0 pl-3 pr-0 ml-0 ml-0">
		<v-row no-gutters class="pb-3">
			<v-col>
				<v-card class="elevation-1 justify-center text-left" color="white">
					<v-card-title id="top" class="primary--text pb-0">
						<v-row class="pb-0 mb-0" :cols="12">
							<v-col>
								<v-btn class="primary--text" left text @click="cancelLocumSearch()"><v-icon left large color="primary">mdi-close</v-icon>Cancel</v-btn>
							</v-col>
						</v-row>
					</v-card-title>

					<v-card-text>
						<v-divider class="mb-4"></v-divider>
						<v-row>
							<v-col>
								<div class="title black--text font-weight-black text-center">Confirm Date Selection</div>
							</v-col>
						</v-row>
						<v-divider class="mb-4 mt-4"></v-divider>
						<v-row>
							<v-col class="date-selection-wrapper">
								<v-checkbox v-model="AllDates" label="Select All Dates" @click="SelectAllDates()"></v-checkbox>
							</v-col>
						</v-row>
						<v-row :key="keyboi">
							<v-col class="date-selection-wrapper">
								<div id="date-selection-start"></div>
								<v-row v-for="(day, index) in this.locumAvailability" :key="'card-' + index" no-gutters>
									<v-col class="ml-0 pl-0">
										<v-card elevation="0" class="pl-2 mt-1 mb-1 ml-0 mr-0" align="left" justify="left">
											<v-row no-gutters>
												<v-col
													cols="1"
													class="mr-0 pl-0 mt-5 pt-1 justify-center text-center cursor-pointer"
													align="center"
													justify="center"
													@click="isDayAvailable(day) ? dateSelected(index) : () => {}"
												>
													<span v-if="isDayAvailable(day)" :color="colorOfIndex(index)">
														<v-icon v-if="trackedDates[index]" :color="colorOfIndex(index)">radio_button_checked</v-icon>
														<v-icon v-else :color="colorOfIndex(index)">radio_button_unchecked</v-icon>
													</span>
													<span v-else color="red">
														<v-icon color="grey">not_interested</v-icon>
													</span>
												</v-col>
												<v-col
													cols="3"
													class="pl-2 pt-2 justify-center text-center cursor-pointer"
													@click="isDayAvailable(day) ? dateSelected(index) : () => {}"
												>
													<CalendarDateIcon :date="day.date" :color="getDayColor(day)"></CalendarDateIcon>
												</v-col>
												<v-col cols="8" class="pl-2 ml-0">
													<v-row no-gutters>
														<v-col class="pb-0 pt-0">
															<span style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 14px; line-height: 17px">{{
																getDayStatus(day)
															}}</span>
															<v-tooltip top nudge-right class="cursor-help">
																<template #activator="{ on }">
																	<v-icon class="ml-1" color="grey lighten-1" small v-on="on">help</v-icon>
																</template>
																<span>{{ getDayTooltipMessage(day) }}</span>
															</v-tooltip>
														</v-col>
													</v-row>
													<v-row no-gutters>
														<v-col class="pt-0">
															<v-row no-gutters>
																<v-col class="pt-0 pb-0">
																	<span style="font-family: Montserrat; font-style: normal; font-weight: 500; font-size: 12px; line-height: 15px"
																		>{{ day.start_time }} → {{ day.end_time }} ({{ hoursBetween(day) }}hrs)</span
																	>
																	<!-- <v-icon v-if="isDayAvailable(day)" color="grey" class="ml-2" size="22" @click="editDateTimes(day, index)"
																		>edit</v-icon
																	> -->
																	<v-tooltip v-if="isTwoDayShift(day)" top nudge-right class="cursor-help">
																		<template #activator="{ on }">
																			<v-icon color="grey" class="ml-2" size="22" v-on="on">mdi-calendar-blank-multiple</v-icon>
																		</template>
																		<span>Event spans multiple days. The date indicates the starting date of the shift</span>
																	</v-tooltip>
																	<!-- <v-tooltip v-if="isNightShift(day)" top nudge-right class="cursor-help">
																		<template #activator="{ on }">
																			<v-icon color="grey" class="ml-2" size="22" v-on="on">mdi-weather-night</v-icon>
																		</template>
																		<span>Events that start after 7PM are classed as night shifts. This may affect the booking total.</span>
																	</v-tooltip> -->
																</v-col>
															</v-row>
															<v-row v-if="getCostOfDay(index) > 0" no-gutters>
																<v-col v-if="'working_hours' in locum" class="pt-0">
																	<span style="font-family: Montserrat; font-style: normal; font-weight: 500; font-size: 12px; line-height: 15px"
																		>Estimated day rate → R
																		{{ getCostOfDay(index) }}
																	</span>
																</v-col>
															</v-row>
															<v-row v-else no-gutters>
																<v-col v-if="'working_hours' in locum" class="pt-0">
																	<span style="font-family: Montserrat; font-style: normal; font-weight: 500; font-size: 12px; line-height: 15px"
																		>Estimated day rate unavailable</span
																	>
																</v-col>
															</v-row>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>
								<v-row class="mt-2">
									<v-col class="primary--text">
										<v-btn
											class="primary--text"
											text
											@click="
												() => {
													scrollIntoView('date-selection-start');
												}
											"
										>
											<v-icon dense large color="primary">keyboard_arrow_up</v-icon> Back to top
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
						<v-divider class="mt-4"></v-divider>
						<div>
							<booking-cost-summary :dates="selectedDates" :locum="locum" :booking="originalCriteria"></booking-cost-summary>
						</div>
						<v-row class="mt-2">
							<v-col>
								<v-textarea v-model="notes" hide-details label="Notes (optional)" background-color="#F4F4F4" rounded outlined no-resize></v-textarea>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn
									id="send_booking_request_button"
									:disabled="selectedDates.length === 0"
									rounded
									block
									color="#63C367"
									class="white--text text-none mt-2"
									:loading="isLoading"
									@click="gotoBookingSummary"
								>
									Send Booking Request
								</v-btn>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-dialog v-model="showTimeEdit" width="700">
			<v-card>
				<v-card-title class="text-h6 grey lighten-2">Edit shift time for {{ getDayDisplayName(activeEditDay) }} </v-card-title>

				<div class="ml-4 mr-4 mt-4">
					<p class="font-weight-bold">Time</p>

					<v-row>
						<v-col>
							<v-dialog ref="startTimeDialog" v-model="startTimeModal" :return-value.sync="startTime" persistent width="290px">
								<template #activator="{ on }">
									<v-text-field v-model="startTime" label="Start Time:" placeholder="Start Time:" readonly filled dense v-on="on"></v-text-field>
								</template>
								<v-time-picker
									v-if="startTimeModal"
									v-model="startTime"
									:min="activeEditDay.availability ? activeEditDay.availability.start_time : '00:00'"
									full-width
									format="24hr"
									:allowed-minutes="[0, 15, 30, 45]"
								>
									<v-spacer></v-spacer>
									<v-btn text color="primary" @click="startTimeModal = false">Cancel</v-btn>
									<v-btn text color="primary" @click="$refs.startTimeDialog.save(startTime)">OK</v-btn>
								</v-time-picker>
							</v-dialog>
						</v-col>

						<v-col>
							<v-dialog ref="endTimeDialog" v-model="endTimeModal" :return-value.sync="endTime" persistent width="290px">
								<template #activator="{ on }">
									<v-text-field v-model="endTime" label="End Time" placeholder="End Time:" readonly filled dense v-on="on"></v-text-field>
								</template>
								<v-time-picker
									v-if="endTimeModal"
									v-model="endTime"
									:max="activeEditDay.availability ? activeEditDay.availability.end_time : '23:45'"
									full-width
									format="24hr"
									:allowed-minutes="[0, 15, 30, 45]"
								>
									<v-spacer></v-spacer>
									<v-btn text color="primary" @click="endTimeModal = false">Cancel</v-btn>
									<v-btn text color="primary" @click="$refs.endTimeDialog.save(endTime)">OK</v-btn>
								</v-time-picker>
							</v-dialog>
						</v-col>
					</v-row>
				</div>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red" text @click="showTimeEdit = false"> Cancel </v-btn>
					<v-btn color="primary" text @click="confirmTimeChanges"> Confirm </v-btn>
				</v-card-actions>
			</v-card></v-dialog
		>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import CalendarDateIcon from '@/components/custom/CalendarDateIcon.vue';
import BookingCostSummary from '@/components/custom/BookingCostSummary.vue';
import { getRelevantProfessions } from '@utils';

import moment from 'moment';
import { bus } from '@/main';

export default {
	name: 'PracticeToLocumCreateBookingRequest',

	components: {
		CalendarDateIcon,
		BookingCostSummary,
	},

	data: () => ({
		keyboi: 0,

		trackedDates: {},
		selectedDates: [],

		apiRequest: false,
		API_URL: store.getters.getAPI,
		notes: '',

		showTimeEdit: false,
		activeEditDay: '',

		startTimeModal: false,
		endTimeModal: false,
		startTime: '09:00',
		endTime: '17:00',
		AllDates: false,

		locumAvailability: [],

		isLoading: false,

		industryKeys: store.getters.configs.industryKeys,
	}),

	computed: {
		...mapGetters('offers', ['offer']),

		originalCriteria() {
			return this.offer; //store.getters.getPracticeOffer;
		},

		locum() {
			return store.getters.getPracticeViewingLocum[0];
		},

		companyAddressAsString() {
			let result = {};
			Object.keys(store.getters.company.address).forEach(key => {
				if (key != 'update_timestamp') {
					result[key] = store.getters.company.address[key];
				}
			});
			return result;
		},

		industriesConfigsObj() {
			return store.getters.configs.industries;
		},
	},

	mounted() {
		const mappedAvailableDays = this.locum.available_dates.map(day => {
			if (this.originalCriteria && this.originalCriteria.request_dates) {
				const requestDate = this.originalCriteria.request_dates.find(date => date.date === day.date);

				// if requestDate is undefined return null
				if (!requestDate) {
					return null;
				}

				const start_time = moment(requestDate.start_time).format('HH:mm');
				const end_time = moment(requestDate.end_time).format('HH:mm');
				return {
					...day,
					start_time,
					end_time,
				};
			} else {
				const { start_time, end_time } = day.availability || this.originalCriteria;
				return {
					...day,
					start_time,
					end_time,
				};
			}
		});
		this.notes = this.originalCriteria.notes;
		this.locumAvailability = mappedAvailableDays.filter(value => value !== null);
	},

	methods: {
		...mapActions(['SET_PRACTICE_REQUESTS_SENT', 'SET_PRACTICE_LOCUMS_APPLIED_TO']),

		...mapActions('offers', ['UpsertPrivateOffer', 'UpsertOffer']),

		getCostOfDay(index) {
			const dayHours = this.hoursBetween(this.locumAvailability[index]);

			const hoursIncLunch = dayHours;

			const type = this.getDayType(index);

			return this.getDayRate(type) * hoursIncLunch;
		},

		getLunchHours() {
			const { allowed, paid, period } = store.getters.getPracticeOffer?.lunch;

			return { allowed, paid, period };
		},

		getDayType(index) {
			const public_holidays = store.getters.getPublicHolidays || [];
			const { date } = this.locumAvailability[index];

			const [year, month, day] = date.split('-');
			const formattedDate = `${year}-${day}-${month}`;

			const dayOfWeek = moment(date).day();
			const publicHolidayRate = public_holidays.includes(formattedDate);

			if (publicHolidayRate || dayOfWeek === 0) {
				return 'sundaysAndHolidays';
			} else {
				if (dayOfWeek === 6) {
					return 'saturday';
				} else {
					return 'weekdays';
				}
			}
		},

		getTimeField(type, availability) {
			return availability ? availability[type] : this.originalCriteria[type];
		},

		getDayRate(type) {
			const { working_hours } = this.locum;
			const typeFinal = type === 'sundaysAndHolidays' ? 'sundays' : type;
			return working_hours ? Number(working_hours[typeFinal].rate) : 0;
		},

		scrollIntoView(thing) {
			document.getElementById(thing).scrollIntoView();
		},

		getDayStatus({ date }) {
			const { status } = this.locum.available_dates.find(({ date: availDate }) => date === availDate) || {};
			return status;
		},

		isDayAvailable(day) {
			return !['Requested', 'Unavailable'].includes(this.getDayStatus(day));
		},

		getDayColor(day) {
			const dayStatus = this.getDayStatus(day);
			switch (dayStatus) {
				case 'Possibly Available':
					return 'primary';
				case 'Available':
					return '#63C367';
				case 'Unavailable':
					return '#9B9B9B';
			}
		},

		getDayTooltipMessage(day) {
			const dayStatus = this.getDayStatus(day);
			switch (dayStatus) {
				case 'Possibly Available':
					return 'Locum may possibly be available on this date';
				case 'Available':
					return 'Locum set an availability but is not guaranteed at time of request';
				case 'Unavailable':
					return 'Locum is booked or not available on this date';
			}
		},

		getDayDisplayName({ date }) {
			const dayOfWeek = moment(date).format('dddd');
			const dateOfMonth = moment(date).format('DD');
			const month = moment(date).format('MMMM');
			return `${dayOfWeek} ${dateOfMonth} ${month}`;
		},

		getStartEndDates(start_time, end_time, date) {
			const start = moment(`${date} ${start_time}`);
			let end = moment(`${date} ${end_time}`);
			return { start, end };
		},

		hoursBetween(day) {
			const { start_time, end_time, date } = day;
			let { start, end } = this.getStartEndDates(start_time, end_time, date);
			const isTwoDays = this.isTwoDayShift(day);
			if (isTwoDays) {
				end = moment(end).add('days', 1);
			}
			return Math.fround(
				moment()
					.add(moment.duration(end))
					.diff(moment().add(moment.duration(start)), 'hours', true)
			).toFixed();
		},

		isTwoDayShift({ start_time, end_time, date }) {
			let { start, end } = this.getStartEndDates(start_time, end_time, date);
			return moment(start).isAfter(end);
		},

		isNightShift({ start_time, end_time, date }) {
			let { start } = this.getStartEndDates(start_time, end_time, date);
			return moment(start).isAfter(`${date} 18:59:59`);
		},

		viewLocumProfile() {
			bus.$emit('change-context', 'practice-locum-profile');
		},

		cancelLocumSearch() {
			if (this.locum.previousContext) {
				bus.$emit('change-context', this.locum.previousContext);
			} else {
				bus.$emit('change-context', 'view-locum-details-card');
			}
		},

		async gotoBookingSummary() {
			const company = store.getters.company;
			// const user = store.getters.user;

			this.isLoading = true;
			let days = [];
			Object.keys(this.trackedDates).forEach(index => {
				let tracked = this.trackedDates[index];
				let availability = this.locumAvailability[index];
				if (tracked) {
					days.push(availability);
				}
			});

			let datesOnly = [];
			Object.keys(this.trackedDates).forEach(index => {
				let tracked = this.trackedDates[index];
				let availability = this.locumAvailability[index];
				if (tracked) {
					datesOnly.push(availability.date);
				}
			});

			const relevantProfessions = getRelevantProfessions(company.industry, this.industriesConfigsObj);

			await store.dispatch('PERFORM_LOCUM_SEARCH_DATES', {
				professions: relevantProfessions,
				profession: company.industry,
				location: `${company.address.province},${company.address.region}`,
				dates: datesOnly,
			});

			await this.sendPrivateBookingRequest(days);
			this.isLoading = false;
		},

		colorOfIndex(index) {
			if (!(index in this.trackedDates)) {
				this.trackedDates[index] = false;
			}
			return this.trackedDates[index] ? 'green' : 'red';
		},

		editDateTimes(day, index) {
			const { start_time, end_time } = day;
			this.activeEditDay = { ...day, index };
			this.startTime = start_time;
			this.endTime = end_time;
			this.showTimeEdit = true;
		},

		confirmTimeChanges() {
			const { date, index } = this.activeEditDay;

			this.locumAvailability = this.locumAvailability.map(day => {
				if (day.date === date) {
					day.start_time = this.startTime;
					day.end_time = this.endTime;
					day.isEdit = true;
				}
				return day;
			});

			const matchingDateIndex = this.selectedDates.findIndex(arrDate => arrDate.date === date);

			if (matchingDateIndex > -1) {
				const arr = this.selectedDates.splice();
				arr[index] = {
					date: this.selectedDates[index].date,
					start_time: this.startTime,
					end_time: this.endTime,
				};
				this.selectedDates = arr;
			} else {
				this.dateSelected(index, true);
			}

			this.showTimeEdit = false;
		},

		addSelectedDate(index) {
			const { date, availability } = this.locumAvailability[index];
			let { start_time, end_time, isEdit = false } = this.locumAvailability[index];

			start_time = isEdit ? start_time : this.getTimeField('start_time', availability);
			end_time = isEdit ? end_time : this.getTimeField('end_time', availability);

			const dateSelected = {
				date,
				start_time,
				end_time,
			};

			const matchingDate = this.selectedDates.find(arrDate => arrDate.date === date);
			const isSelected = this.trackedDates[index];

			if (!matchingDate && isSelected) {
				this.selectedDates.push(dateSelected);
			} else {
				this.selectedDates = this.selectedDates.filter(arrDate => arrDate.date !== date);
			}
		},

		dateSelected(index) {
			if (!(index in this.trackedDates)) {
				this.trackedDates[index] = true;
			} else {
				this.trackedDates[index] = !this.trackedDates[index];
			}

			this.addSelectedDate(index);
		},

		getRequestDates() {
			return this.locumAvailability
				.filter((_, index) => this.trackedDates[index])
				.map(day => {
					const { date, start_time, end_time, availability } = day;
					const isoStart = moment(`${date} ${start_time}`).format();
					let isoEnd = moment(`${date} ${end_time}`).format();
					const isNightShift = this.isTwoDayShift(day);
					if (isNightShift) {
						isoEnd = moment(isoEnd).add('days', 1).format();
					}
					let availabilityObject = {};
					if (availability) {
						availabilityObject = { availability };
					}
					return {
						date,
						start_time: isoStart,
						end_time: isoEnd,
						...availabilityObject,
					};
				});
		},

		getMappedSkills(skills) {
			return skills.map(code => ({ code, name: this.industryKeys[code] }));
		},

		async sendPrivateBookingRequest(days) {
			const locum = this.locum;
			days.sort((a, b) => moment(a.date).diff(moment(b.date)));

			// this one is givenig problems

			const request_dates = this.getRequestDates();

			const { start_time, end_time, company, profession, experience, languages, lunch, rates, skills = [] } = this.originalCriteria;

			delete company.address.update_timestamp;

			const { id, first_name: name, last_name: surname, contact, profession: locumProfession, email, qualifications, working_hours, experience: locumExperience } = locum;

			const mappedSkills = this.getMappedSkills(skills);

			// console.log(this.originalCriteria);

			const payload = {
				start_time,
				end_time,
				date: days[0].date,
				end_date: days[days.length - 1].date,
				company,
				notes: this.notes,
				profession,
				experience,
				languages,
				skills: mappedSkills,
				lunch,
				available_dates: days.map(day => day.date).sort((a, b) => moment(a).diff(moment(b))),
				request_dates,
				rates,
				offers_requests: [
					{
						id,
						name,
						surname,
						contact,
						profession: locumProfession,
						email,
						qualifications: {
							qualification: qualifications.qualification,
							institution: qualifications.institution,
							year_qualified: moment(qualifications.year_qualified).format('YYYY'),
						},
						rates: {
							weekdays: 'R' + working_hours.weekdays.rate,
							saturday: 'R' + working_hours.saturday.rate,
							sundays: 'R' + working_hours.sundays.rate,
							public_holidays: 'R' + locum.working_hours.public_holidays.rate,
						},
						status: 'requested',
						status_reason: '',
						experience: moment(locumExperience.start_date).format('YYYY-MM-DD'),
						booking_dates: days.map(day => day.date).sort((a, b) => moment(a).diff(moment(b))),
					},
				],
			};

			try {
				await this.UpsertPrivateOffer(payload);

				this.SET_PRACTICE_REQUESTS_SENT([
					{
						body: payload,
					},
				]);

				this.SET_PRACTICE_LOCUMS_APPLIED_TO(id);
				setTimeout(() => {
					bus.$emit('UpdateCalendar');
				}, 500);
				bus.$emit('change-context', 'practice-request-multiple-locums');
			} catch (err) {
				console.error('Failed to create private offer', err);
			}
		},

		async sendBookingRequest(days) {
			let availabilities = {};
			days.forEach(day => {
				if (!(day.availability.date in availabilities)) {
					availabilities[day.availability.date] = [];
				}
				availabilities[day.availability.date].push(day);
			});

			try {
				const requests = [];
				for (let group_of_availability_days of Object.values(availabilities)) {
					const payload = {
						id: this.originalCriteria.company.id,
						name: store.getters.company.name,
						email: store.getters.company.email,
						contact: this.originalCriteria.company.contact,
						industry: this.originalCriteria.company.industry,
						start_time: this.originalCriteria.start_time,
						end_time: this.originalCriteria.end_time,
						address: this.companyAddressAsString,
						lunch: this.originalCriteria.lunch,
						notes: this.notes,
						rates: this.originalCriteria.rates,
						status: 'requested',
						booking_dates: group_of_availability_days.map(day => day.date).sort((a, b) => moment(a).diff(moment(b))),
					};

					await this.UpsertOffer({
						offer: payload,
						professionalId: group_of_availability_days[0].availability.id,
						date: group_of_availability_days[0].availability.date,
					});

					requests.push({
						body: payload,
					});
				}

				this.SET_PRACTICE_REQUESTS_SENT(requests);
				this.SET_PRACTICE_LOCUMS_APPLIED_TO(this.locum.id);
				bus.$emit('change-context', 'practice-request-multiple-locums');
			} catch (err) {
				console.error('Fialed to create private offer', err);
			}
		},

		async SelectAllDates() {
			if (this.AllDates) {
				this.trackedDates = [];
				this.locumAvailability.forEach((day, index) => {
					if (this.isDayAvailable(day)) this.dateSelected(index);
				});
			} else if (!this.AllDates) {
				this.trackedDates = [];
				this.locumAvailability.forEach((day, index) => {
					this.trackedDates[index] = false;
				});
			}
		},
	},
};
</script>

<style scoped>
.date-selection-wrapper {
	max-height: 400px;
	overflow-y: auto;
}

.cursor-pointer {
	cursor: pointer;
}

.cursor-help {
	cursor: help;
}
</style>
